import {
  provideHttpClient,
  withInterceptors,
  withXhr,
} from '@angular/common/http';
import {
  ApplicationConfig,
  ErrorHandler,
  inject,
  provideBrowserGlobalErrorListeners,
  provideEnvironmentInitializer,
} from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  provideRouter,
  Router,
  TitleStrategy,
  withComponentInputBinding,
} from '@angular/router';
import { appRoutes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { apiResponseInterceptor } from './core/interceptors/response.interceptor';
import { GlobalErrorHandler } from './core/handlers/global-error.handler';
import { LocalStorageService } from './core/services/local-storage/local-storage.service';
import { TranslationService } from './core/services/translation/translation.service';
import { PageTitleStrategy } from './core/strategies/page-title.strategy';
import { DeployRefreshService } from './core/services/deploy-refresh/deploy-refresh.service';
import { ThemeSwitcherService } from './core/themes/theme-switcher.service';
import { environment } from './environments/environment';
import { TranslatePipe } from './shared/pipes/translate/translate.pipe';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(appRoutes, withComponentInputBinding()),
    provideAnimations(),
    /**
     * Use environmentInitializers instead of useFactory + deps to avoid circular DI
     */
    provideEnvironmentInitializer(async () => {
      const localStorageService = inject(LocalStorageService);
      localStorageService.init(environment);

      const translationService = inject(TranslationService);
      await translationService.init(environment);
    }),
    provideEnvironmentInitializer(() => {
      inject(DeployRefreshService).start(inject(Router));
    }),
    provideHttpClient(
      withXhr(),
      withInterceptors([authInterceptor, apiResponseInterceptor])
    ),
    TranslatePipe,
    TranslationService,
    LocalStorageService,
    ThemeSwitcherService,
    { provide: TitleStrategy, useClass: PageTitleStrategy },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
  ],
};
